import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T30BossWindow() {
/*
  useEffect(() => {
    UserService.sendEvent('BossWindow30');
  }, []); */


  const text = 'Lesson one — you must defeat my assistant.'
    return (
        <div>

            <div className={'BossWindow30Top'}></div>
            <div className={'clickBoss20Right'}></div>
            <div className={'BossWindow30Left'}></div>

            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialTopContainer'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T30BossWindow;
